module.exports = __webpack_public_path__ + "img/logo2.7bb0bddc.png";